import React from 'react';
import { Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

export default function UpdateBills() {
  return (
    <div>
      No data to display.{' '}
      <LinkContainer
        to={'/accounts'}
        style={{
          display: 'inline-block',
          marginLeft: '0px',
          paddingLeft: '0px',
        }}
      >
        <Nav.Link>{'Are your utility bills up to date?'}</Nav.Link>
      </LinkContainer>
    </div>
  );
}
